import storageService from './services/storage/StorageService';
import configuration from './configurations';
import { setStorageInstance } from './storage';

/**
 * Initialize Storage
 * Call this function early in your app initialization (e.g., in index.js or App.js)
 */
export async function initializeStorage() {
    try {
        console.log('Initializing storage service...');

        const storageConfig = configuration.storage || {
            USE_INDEXDB: true,
            DB_NAME: 'picourt-app-db',
            DB_VERSION: 1,
            STORE_NAME: 'key-value-store'
        };

        const storageInstance = await storageService.initialize(storageConfig);

        // Set global storage instance
        setStorageInstance(storageInstance);

        console.log('✅ Storage initialized successfully');
        console.log('Storage type:', storageInstance.constructor.name);

        return storageInstance;
    } catch (error) {
        console.error('❌ Failed to initialize storage:', error);
        throw error;
    }
}

/**
 * Get storage instance
 * Use this to access storage throughout your app
 */
export function getStorage() {
    return storageService.getStorage();
}

export default { initializeStorage, getStorage };
